module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "figcenter",
    attrs: {
      "id": "illus1"
    }
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "",
      "id": "id-1251631314840333016",
      "src": "Images/img0001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("TWILIGHT AT MIDDAY, FEBRUARY 1874.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00004",
      "title": "[iv]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_iv",
      "title": "[iv]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00005",
      "title": "[v]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_v",
      "title": "[v]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0